exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.global-admin #connections-add-page .page-content[data-v-7e05674a] {\n    height: calc(100vh - 90px);\n}\n", ""]);

// exports
